import exchange from './exchange';
import sell from './sell';
import transfer from './transfer';
import withdraw from './withdraw';

export default {
  bean: 'فاصوليا',
  coffee: 'قهوة',
  pearl: 'لؤلؤة',
  gem: 'جوهرة',
  coin: 'عملات ذهبية',
  coins: 'عملات ذهبية',
  send: {
    details: 'التفاصيل',
  },
  exchange,
  transfer,
  withdraw,
  sell,
};
